export default "__VITE_ASSET__CWgYpBjb__"